import * as React from 'react';
import {
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useConsentStyles } from './styles';
import { scopeLabel } from './translations';

// Only the requested scopes are listed, so the user can only narrow the
// request. Read scopes come first and write scopes after, with a textual badge.
export default function ScopeChecklist({ scopes, checked, onToggle, disabled }) {
  const { t } = useTranslation();
  const classes = useConsentStyles();
  const ordered = [
    ...scopes.filter((item) => item.access !== 'write'),
    ...scopes.filter((item) => item.access === 'write'),
  ];

  return (
    <FormControl component="fieldset" fullWidth disabled={disabled}>
      <FormLabel component="legend">{t('mcp.consent.permissionsLabel')}</FormLabel>
      <FormGroup>
        {ordered.map((item) => (
          <FormControlLabel
            key={item.scope}
            className={classes.row}
            control={
              <Checkbox
                color="secondary"
                checked={!!checked[item.scope]}
                onChange={() => onToggle(item.scope)}
              />
            }
            label={
              <span className={classes.literal}>
                <Typography variant="body1" component="span" className={classes.literal}>
                  {scopeLabel(t, item)}
                </Typography>
                {item.access === 'write' && (
                  <Typography variant="caption" component="span" display="block">
                    <span className={classes.badge}>{t('mcp.consent.writeBadge')}</span>
                  </Typography>
                )}
              </span>
            }
          />
        ))}
      </FormGroup>
    </FormControl>
  );
}
